import { Box, Button, FormHelperText, Stack, Typography } from "@mui/material";
import Fade from "@mui/material/Fade";
import { SignUpForm } from "./partials/SignUpForm";
import { Header } from "./partials/Header";
import { Footer } from "./partials/Footer";
import { Container } from "./partials/Container";
import { GoogleAuthButton, TextualDivider } from "../../components";
import { SubmitButton } from "./partials/SubmitButton";
import { useSignUpPageFacade } from "./hooks/useSignUpPageFacade";
import { FONT_COLORS } from "../../constants";
import EnvelopIcon from "../../assets/envelop.svg";

const SignUp = () => {
  const {
    email,
    errors,
    resendingEmail,
    resendEmail,
    handleSignUpSuccess,
    navigateToLogin,
  } = useSignUpPageFacade();

  return (
    <Container>
      <Fade in={!!email} timeout={1000}>
        <Stack
          width="100%"
          alignItems="center"
          display={!!email ? "flex" : "none"}
        >
          <Box width={88} height={88} mb={2}>
            <img
              src={EnvelopIcon}
              alt="Envelop icon"
              width="100%"
              height="100%"
            />
          </Box>
          <Header
            disableCompanyIdentity
            title="Verify your email"
            subtitle={
              <Typography
                variant="h2"
                component="h2"
                fontSize={16}
                fontWeight={400}
                textAlign="center"
                color={FONT_COLORS.default}
              >
                We have sent a verification email to{" "}
                <Typography
                  variant="h2"
                  fontSize={16}
                  fontWeight={700}
                  color={FONT_COLORS.default}
                  component="strong"
                >
                  {email}.
                </Typography>
                <Typography
                  variant="h2"
                  component="h2"
                  fontSize={16}
                  fontWeight={400}
                  textAlign="center"
                  color={FONT_COLORS.default}
                >
                  Please verify your email to continue
                </Typography>
              </Typography>
            }
          />
          <SubmitButton
            loading={resendingEmail}
            onClick={() => resendEmail(email)}
          >
            Resend Link
          </SubmitButton>
          {!!errors.resendVerificationEmailFailed && (
            <FormHelperText error sx={{ alignSelf: "flex-start" }}>
              {errors.resendVerificationEmailFailed}
            </FormHelperText>
          )}
          <TextualDivider>Or</TextualDivider>
          <Button
            disabled={resendingEmail}
            variant="text"
            onClick={navigateToLogin}
          >
            Return to Login
          </Button>
        </Stack>
      </Fade>
      <Fade in={!email} timeout={1000}>
        <Stack width="100%" display={!email ? "flex" : "none"}>
          <Header
            title="Sign Up"
            subtitle="Join thousands of Amazon sellers already turning data into profits with our platform"
            disableCompanyIdentity
          />
          {/* <GoogleAuthButton text="signup_with" />
          <TextualDivider>Or, Sign up with your email</TextualDivider> */}
          <SignUpForm onSuccess={handleSignUpSuccess} />
          <Footer
            text="Already have an account?"
            linkText="Sign In"
            link="/login"
          />
        </Stack>
      </Fade>
    </Container>
  );
};

export default SignUp;
